import { DialogContent, LinearProgress } from "@mui/material";
import React from "react";

export const DialogLoadingContainer = () => {
  return (
    <DialogContent style={{ padding: "20px" }}>
      <LinearProgress />
    </DialogContent>
  );
};
